<template>
    <div>
        <slot :getDataField="getDataField" :getFilteredDataField="getFilteredDataField">
            <div class="singleItem container-flex page-content">
                <div v-if="$store.state.items.isAddToBasketLoading != 0" class="item-loading-splash-screen">
                    <icon icon="spinner" :loading="$store.state.items.isAddToBasketLoading != 0"></icon>
                </div>
                
                <div class="topItemContent">

                    <div class="itemImageGallery" :class="galleryDivision">
                        <slot name="image-carousel"></slot>
                        <!-- Open in Laura CubeConfig -->
                        <a v-if="cubeConfigLink" 
                            :href="cubeConfigLink" 
                            class="openLauraPlanner btn-sm btn-bkm-inverted btn" 
                            v-html="$translate('naturwohnenTheme::Template.openSetInPlanner')"></a>
                    </div>

                    <div class="itemDetails">
                        <div class="sticky">
                            <!-- START SINGLEITEM_DETAILS -->

                            <h1 class="h2 title" data-testing="item-name" v-html="variationName"></h1>
                            
                            <feedback-average class="box-feedback" :show-empty-ratings="true" size-of-stars="small" :show-ratings-amount="true"></feedback-average>

                            <client-only v-if="currentVariation.variation.availability.id == 1">
                                <nw-availability :standalone="true" :our-furniture="ourFurniture" :avd="templateData"></nw-availability>
                            </client-only>

                            <variation-measurement :variation-properties="variationProperties"></variation-measurement>

                            <ul v-if="variationBulletpoints.length" class="list-unstyled variationBulletpoints">
                                <li v-for="bullet in variationBulletpoints" v-html="bullet"></li>
                                <li class="learnMore" @click="scrollToDescription">Mehr erfahren</li>
                            </ul>

                            <div class="mb-1" v-if="attributes.length">
                                <variation-select></variation-select>
                            </div>

                            <div class="priceBox">
                                <img v-if="ourFurniture" src="https://s3-eu-central-1.amazonaws.com/plentymarkets-public-92/3aiz45agf6oo/plugin/50/naturwohnentheme/images/assets/Naturwohnen.png" alt="Naturwohnen" />
                                <item-price :show-cross-price="true" :show-sale="showSale"></item-price>
                            </div>

                            <slot name="after-price"></slot>

                            <!-- Shop Sale -->
                            <div class="shopSale" v-if="showSale">
                                <div class="shopSale-content">
                                    <div class="shopSale-text">
                                        <sale-countdown></sale-countdown>
                                        <div class="saleName" v-html="$ceres.nwConfig.shopSale.saleLabel"></div>
                                    </div>
                                    <div class="couponCopyCont">
                                        <coupon-copy></coupon-copy>
                                    </div>
                                    <sale-conditions></sale-conditions>
                                </div>
                            </div>
                            
                            <!-- /Variation -->
                            <!-- ORDER PROPERTIES -->
                            <section class="accordion availabilityBox">
                                <div class="accordionItem availability">
                                    <img class="nwicon" src="https://cdn1.naturwohnen.de/frontend/naturwohnen/ico/check.svg" alt="Verfuegbarkeit" />
                                    <client-only>
                                        <nw-availability :our-furniture="ourFurniture" :avd="templateData"></nw-availability>
                                    </client-only>
                                </div>
                                <div class="accordionItem shipping">
                                    <img class="nwicon" src="https://cdn1.naturwohnen.de/frontend/naturwohnen/ico/shipping.svg" alt="Versand und Rueckgabe" />
                                    <span class="label">
                                        Versand & Rückgabe
                                    </span>
                                    <span class="text">
                                        <button @click="showShipping" class="shipping">
                                            <span v-html="shipsWith.name"></span><i class="fa fa-info"></i>
                                        </button>
                                    </span>
                                </div>
                                <div class="accordionItem availability" v-if="currentVariation.filter.isSalable && variationGroupedProperties.length">
                                    <img class="nwicon" src="https://cdn1.naturwohnen.de/frontend/naturwohnen/ico/construction.svg" alt="Aufbauservice" />
                                    <order-property-list></order-property-list>
                                </div>
                            </section>


                            <div class="addToBasketContainer">
                                <div class="w-100">
                                    <slot name="before-add-to-basket"></slot>
                                </div>

                                <div v-if="currentVariation.item.itemType === 'set'" class="alert alert-info w-100">
                                    {{ $translate("Ceres::Template.singleItemSetInfo") }}
                                </div>
                                
                                <div class="basketWishlist">
                                    <add-to-basket
                                        :variation-id="currentVariation.variation.id"
                                        :is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
                                        :has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
                                        :interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
                                        :minimum-quantity="currentVariation.variation.minimumOrderQuantity"
                                        :maximum-quantity="!!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null"
                                        :order-properties="currentVariation.properties.filter(function(prop) { return prop.property.isOderProperty })"
                                        :has-order-properties="currentVariation.hasOrderProperties"
                                        :has-required-order-property="currentVariation.hasRequiredOrderProperty"
                                        :use-large-scale="false"
                                        :show-quantity="true"
                                        :item-url="currentVariation | itemURL"
                                        :is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
                                        :has-price="currentVariation | hasItemDefaultPrice"
                                    ></add-to-basket>
                                    <add-to-wish-list :variation-id="currentVariation.variation.id"></add-to-wish-list>
                                </div>

                                <div class="share d-none">
                                    {{ $translate("naturwohnenTheme::Template.shareLabel") }}
                                    <share :title="currentVariation.texts.name1 + $translate('naturwohnenTheme::Template.shareTitleSuffix')"
                                    :mode="'text'"></share>
                                </div>
                                
                                <div class="w-100">
                                    <slot name="after-add-to-basket"></slot>
                                </div>
                            </div>
                            <!-- ./ITEM DETAIL -->
                            <slot name="additional-content-after-add-to-basket"></slot>

                            <slot name="additional-content-after-vat"></slot>
                            <!-- END SINGLEITEM_DETAILS -->
                        </div>
                    </div>
                </div>

                <div class="qualityIcons" ref="qualityIcons" v-if="qualityIcons.length > 0">
                    <div class="splide__track">
                        <div class="splide__list">
                            <div class="icon splide__slide" v-for="icon in qualityIcons">
                                <img :src="'https://cdn02.plentymarkets.com/3aiz45agf6oo/frontend/naturwohnen/ico/'+ icon.icon +'.svg'" />
                                <span v-html="icon.name"></span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="itemContent">
                    <div class="qualityIcons d-none" v-if="qualityIcons.length > 0">
                        <i v-for="icon in qualityIcons" class="nw-icon" :class="icon"></i>
                    </div>

                    <div class="itemDescription">
                        <section class="technicalImage" v-if="hasProperty(21)">
                            <a v-for="property in variationProperties" 
                                v-if="property.id === 21"
                                :href="'https://cdn1.naturwohnen.de/propertyItems/' + property.value"
                                data-fancybox>
                                <img :src="'https://cdn1.naturwohnen.de/propertyItems/' + property.value" alt="Technical Image" />
                            </a>
                        </section>
                        <section class="textContent accordion" id="product-accordion">
                            <div class="description">
                                <button class="toggleBox" data-toggle="collapse" data-target="#product-description" v-html="$translate('naturwohnenTheme::Template.description')"></button>
                                <div id="product-description" class="textbox collapse show" v-if="hasProperty(291)" v-html="getProperty(291).value"></div>
                                <div id="product-description" class="textbox collapse show" v-else v-html="currentVariation.texts.description"></div>
                            </div>
                            <div class="technicalData">
                                <button class="toggleBox collapsed" data-toggle="collapse" data-target="#tech-data" v-html="$translate('naturwohnenTheme::Template.technicalData')"></button>
                                <div id="tech-data" class="textbox collapse">
                                    <div class="techBullets" v-html="technicalDataText"></div>
                                    <span class="itemNumber">
                                        {{ $translate("naturwohnenTheme::Template.singleItemNumber") }} {{  currentVariation.item.id + '-' + currentVariation.variation.id }}
                                    </span>
                                    <div class="responsible" v-if="showResponsible">
                                        <h4 v-html="$translate('naturwohnenTheme::Template.responsibleHeadline')"></h4>
                                        <p v-html="$translate('naturwohnenTheme::Template.responsibleDescription')"></p>
                                        <div class="card">
                                            <div class="p-0">
                                                <span>{{ currentVariation.item.manufacturer.responsibleName }}</span>
                                            </div>

                                            <div class="p-0">
                                                <span>{{ currentVariation.item.manufacturer.responsibleStreet }}</span>
                                                <span>{{ currentVariation.item.manufacturer.responsibleHouseNo }}</span>
                                            </div>

                                            <div class="p-0">
                                                <span>{{ currentVariation.item.manufacturer.responsiblePostCode }}</span>
                                                <span>{{ currentVariation.item.manufacturer.responsibleTown }}</span>
                                                <span v-if="currentVariation.item.manufacturer.responsibleCountryObject">
                                                {{ currentVariation.item.manufacturer.responsibleCountryObject.name }}
                                                </span>
                                            </div>

                                            <div class="p-0">
                                                <span>{{ currentVariation.item.manufacturer.responsibleEmail }}</span>
                                            </div>

                                            <div class="p-0">
                                                <span>{{ currentVariation.item.manufacturer.responsiblePhoneNo }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="variationCare" v-if="hasProperty(191)">
                                <button class="toggleBox collapsed" data-toggle="collapse" data-target="#variation-care">Pflegehinweise</button>
                                <div id="variation-care" class="textbox collapse" v-html="getProperty(191).value"></div>
                            </div>
                            <div class="deliveryInfo">
                                <button class="toggleBox collapsed" data-toggle="collapse" data-target="#delivery-info"><i class="nw-icon lieferung_icon" alt="Fairer Versand"></i> Versandservice</button>
                                <div id="delivery-info" class="textbox collapse">
                                    <div class="shippingBox">
                                        <div class="head">
                                            <span class="title" v-html="shipsWith.name"></span>
                                            <span class="price">{{ defaultShippingCosts | currency }}</span>
                                        </div>
                                        <span class="text" v-html="shipsWith.text"></span>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>    
                </div>

                <div class="crossSelling accessories">
                    <slot name="cross-selling-accessory"></slot>
                </div>
                
                <div class="additionalInfo">

                    <slot name="series-categories"></slot>

                    <slot name="material-categories"></slot>

                    <manufacturer></manufacturer>

                </div>

                <slot name="item-list-container"></slot>
            
            </div>
        </slot>
        <slot name="feedback-container"></slot>

        <div class="crossSelling products">
            <slot name="cross-selling-similar"></slot>
        </div>


        <slide-content :name="'aufbauservice'" :category-id="1297"></slide-content><!-- Aufbauservice -->
        <slide-content :name="'furniture_deliverytime'" :category-id="1304"></slide-content><!-- Lieferzeit -->
    </div>
</template>

<script>
import { get } from "../../helper/get";
import { isNullOrUndefined } from "../../helper/utils";
import Manufacturer from "./Manufacturer.vue";
import Splide from "@splidejs/splide";

export default {

    name: "single-item",

    props: {
        pleaseSelectOptionVariationId: {
            type: Number,
            default: 0
        },
        initPleaseSelectOption: {
            type: Boolean,
            default: false
        },
        showNetPrices: {
            type: Boolean,
            default: false
        },
        isWishListEnabled: {
            type: Boolean,
            default: false
        },
        itemId: {
            type: Number,
            required: true
        },
        afterKey: Object,
        templateData: Object
    },

    jsonDataFields: [
        "itemData",
        "attributesData",
        "variations"
    ],

    provide()
    {
        return {
            itemId: this.$props.itemId,
            getVariationProperties: () => this.variationProperties,
            getProperty: this.getProperty
        }
    },

    data() {
        return {
            splide: null
        };
    },


    computed:
    {
        itemConfig()
        {
            return App.config.item.itemData;
        },
        hasShippingCostsCategoryId()
        {
            return App.config.global.shippingCostsCategoryId > 0;
        },

        variationGroupedProperties()
        {
            return this.$store.getters[`${this.itemId}/variationGroupedProperties`];
        },

        variationMissingProperties()
        {
            return this.$store.getters[`${this.itemId}/variationMissingProperties`];
        },

        currentVariation() {
            return get(this.$store.state, `items[${this.itemId}].variation.documents[0].data`);
        },

        isVariationSelected() {
            return get(this.$store.state, `items[${this.itemId}].variationSelect.isVariationSelected`);
        },

        attributes() {
            return get(this.$store.state, `items[${this.itemId}].variationSelect.attributes`);
        },

        units() {
            return get(this.$store.state, `items[${this.itemId}].variationSelect.units`);
        },

        isItemSet() {
            return this.$store.state.items.isItemSet;
        },

        variationName() {
            if(this.currentVariation.texts.name2.trim() != "" && this.currentVariation.texts.name2.trim() != "N / A")
            {
                return this.currentVariation.texts.name2 + '<span class="var">' + this.currentVariation.variation.name + '</span>';
            }
            return this.currentVariation.texts.name1 + '<span class="var">' + this.currentVariation.variation.name + '</span>';
        },

        variationBulletpoints() {
            // Helper function collect( (array)ids )
            const collect = ids =>
                this.variationProperties
                .filter(p => ids.includes(p.id))
                .map(p => p.value)
                .filter(v => typeof v === "string" && v.trim());

            const primary = collect([297, 298, 299, 300, 301]);
            return primary.length ? primary : collect([178, 179, 180, 181, 182]);
        },

        variationProperties()
        {
            if (!this.currentVariation || !this.currentVariation.variationProperties) {
                return [];
            }

            let properties = this.currentVariation.variationProperties
                .filter(propertyGroup => propertyGroup.properties && propertyGroup.properties.length > 0) // Ensure properties array exists
                .map(propertyGroup => propertyGroup.properties) // Get the properties arrays
                .flat(); // Flatten the array of arrays into a single array of properties
            
            let out = [];
            for(let prop of properties)
            {
                let obj = {
                    id: prop.id,
                    name: prop.names.name,
                    type: prop.cast,
                    value: Array.isArray(prop.values) ? prop.values.map(val => val.value) : (prop.values.value || null),
                    selectionId: Array.isArray(prop.values) ? prop.values.map(val => val.selectionId) : (prop.values.selectionId || null)
                };
                out.push(obj);
            }
            return out;
        },

        technicalDataText() {
            let nwTechData = this.getProperty(302)?.value || null;
            if(nwTechData && nwTechData.trim() !== "")
            {
                return nwTechData;
            }
            
            return this.currentVariation.texts.technicalData;
        },

        qualityIcons()
        {
            let icons = this.getProperty(288);
            if(icons === null)
            {
                return [];
            }

            const lookup = {
                1099 : { icon: "construction", name: "Aufbauservice" }, // "aufbauservice",
                1100 : { icon: "tree", name: "100% Bio-Erlenholz" }, // "erlenholz",
                1101 : { icon: "heart", name: "Fair produziert" }, // "fair",	
                1102 : { icon: "10", name: "Jahre Garantie" }, // "garantie",	
                1103 : { icon: "shipping", name: "Schnelle Lieferung" }, // "lieferung",	
                1104 : { icon: "woodrings", name: "100% Massivholz" }, // "massivholz",	
                1105 : { icon: "leaf", name: "Natürliche Oberfläche" }, // "oberflaeche",	
                1106 : { icon: "drop", name: "Pflegeleicht" }, // "pflegeleicht",	
                1107 : { icon: "seedling", name: "Natürliche Rohstoffe" }, // "rohstoffe",	
                1108 : { icon: "furniture", name: "Vormontiert" }, // "vormontiert",	
                1109 : { icon: "certificate", name: "Zertifiziert" }, // "zertifiziert"
            };
            icons.selectionId = icons.selectionId.filter(id => lookup[id] !== undefined);
            icons.selectionId = icons.selectionId.map(id => lookup[id]);

            return icons.selectionId;
        },

        galleryDivision()
        {
            let returnVal = "gallery-lg";
            if(!this.hasProperty(285))
            {
                return returnVal;
            }

            const galleryClasses = {
                1078: "gallery-lg", // 1/2/3
                1079: "gallery-md", // 2/3/2
                1082: "gallery-dbl"  // 1/1/2
            };
            return galleryClasses[this.getProperty(285).selectionId] || returnVal;
        },
        publicResourcePath()
        {
            return App.publicPath.replace('js/dist/', 'images/');
        },
        shipsWith()
        {
            const carriers = {
                freight: {
                    name: this.$translate("naturwohnenTheme::Template.shippingFreightName"),
                    text: this.$translate("naturwohnenTheme::Template.shippingFreightText"),
                    price: this.$translate("naturwohnenTheme::Template.shippingFreightPrice")
                },
                package: {
                    name: this.$translate("naturwohnenTheme::Template.shippingPackageName"),
                    text: this.$translate("naturwohnenTheme::Template.shippingPackageText"),
                    price: this.$translate("naturwohnenTheme::Template.shippingPackagePrice")
                },
                big_package: {
                    name: this.$translate("naturwohnenTheme::Template.shippingBigpackageName"),
                    text: this.$translate("naturwohnenTheme::Template.shippingBigpackageText"),
                    price: this.$translate("naturwohnenTheme::Template.shippingBigpackagePrice")
                }
            };
            if(typeof this.templateData.shipping !== undefined && this.templateData.shipping !== null && this.templateData.shipping !== "" && carriers[this.templateData.shipping] !== undefined) {
                return carriers[this.templateData.shipping];
            }
            return carriers.freight;
        },
        showResponsible()
        {
          return (typeof this.currentVariation.item.manufacturer.responsibleName !== undefined &&
                  this.currentVariation.item.manufacturer.responsibleName !== null && 
                  this.currentVariation.item.manufacturer.responsibleName !== "");
        },
        showSale()
        {
            const mode = parseInt(App.nwConfig.shopSale.showSingleItem ?? 0, 10);
            const tags = this.currentVariation?.tags;
            const hasTag8 = Array.isArray(tags) && tags.some(tag => tag?.id === 8);

            return !hasTag8 &&
                !this.hasCrossPrice &&
                (mode === 2 || (mode === 1 && this.ourFurniture));
        },
        hasCrossPrice() {
            const hasRrpPrice = !!this.currentVariation.prices.rrp &&
                this.currentVariation.prices.rrp.unitPrice.value > this.currentVariation.prices.default.unitPrice.value;

            const hasBeforePrice = !!this.currentVariation.prices.specialOffer &&
                !!this.currentVariation.prices.default &&
                this.currentVariation.prices.default.unitPrice.value > this.currentVariation.prices.specialOffer.unitPrice.value;

            return hasRrpPrice || hasBeforePrice;
        },
        ourFurniture()
        {
            if(this.currentVariation.item.manufacturerId == 259 || this.currentVariation.item.manufacturerId == 17)
            {
                return true;
            }
            
            if(!this.currentVariation.tags)
            {
                return false;
            }
            // 160 = our furniture, 63 = shared furniture with bkm
            return this.currentVariation.tags.some(tag => tag.id === 160 || tag.id === 63);
        },
       youSave() {
            // get raw factor (string like "0.2" or "0,2")
            const raw = App.nwConfig.shopSale.singleItemFactor ?? '0'
            // normalize comma → dot, parseFloat (falls back to 0)
            const factor = parseFloat(String(raw).replace(',', '.')) || 0
            // calculate savings
            const savings = factor * this.currentVariation.prices.default.unitPrice.value
            // format as Euro
            return savings.toLocaleString('de-DE', {
                style: 'currency',
                currency: 'EUR'
            })
        },
        priceWithCode()
        {
            if (!this.currentVariation || !this.currentVariation.prices || !this.currentVariation.prices.default) {
                return null;
            }
            const raw = App.nwConfig.shopSale.singleItemFactor ?? '0'
            const factor = parseFloat(String(raw).replace(',', '.')) || 0
            // calculate savings
            const price = (1 - factor) * this.currentVariation.prices.default.unitPrice.value;
            
            if(price <= 0)
                return null;
            // format
            return price.toLocaleString('de-DE', {
                style: 'currency',
                currency: 'EUR'
            })
        },
        cubeConfigLink()
        {
          let prop = this.getProperty(296);
          if(prop && prop.value !== "")
            return `/laura/${prop.value}/`;
          return null;
        },
        defaultShippingCosts() {
            return this.currentVariation?.variation?.defaultShippingCosts ?? 0;
        }
    },

    created()
    {
        this.$store.dispatch("initVariation", this.itemData);
        this.$store.commit(`${this.itemId}/setPleaseSelectVariationId`, this.pleaseSelectOptionVariationId);
    },

    mounted()
    {
        this.$nextTick(() =>
        {
            this.$store.dispatch(`${this.itemId}/variationSelect/setVariationSelect`, {
                itemId:             this.itemId,
                attributes:         this.attributesData,
                variations:         this.variations,
                initialVariationId: this.currentVariation.variation.id,
                isPleaseSelectOption: this.initPleaseSelectOption,
                afterKey:           this.afterKey
            });

            if (this.isItemSet)
            {
                this.$store.dispatch("initSetComponents", this.itemData);   
            }
            
            this.initSplide();
        })

        // listen for variation change to hydrate all children lazy-hydrate components
        document.addEventListener("onVariationChanged", () => {
            this.initSplide();
            this.hydrateChildren(this.$children);
        });
    },

    methods:
    {
        getDataField(field)
        {
            return get(this.currentVariation, field);
        },

        scrollToDescription()
        {
            // Scroll to description
            document.querySelector("#product-description").scrollIntoView({
                behavior: "smooth"
            });
        }, 

        showShipping() 
        {
            $('#delivery-info').collapse('show');
            // Scroll to shipping
            document.querySelector("#delivery-info").scrollIntoView({
                behavior: "smooth"
            });
        },

        formatPrice(price)
        {
            return this.$options.filters.currency(price);
        },

        hasProperty(propertyId)
        {
            return this.variationProperties.some(prop => prop.id === propertyId);
        },

        getProperty(propertyId)
        {
            const property = this.variationProperties.find(prop => prop.id === propertyId);
            if(property)
            {
                return property;
            }
            return null;
        },

        getFilteredDataField(field, filter)
        {
            if (!isNullOrUndefined(this.$options.filters[filter]))
            {
                return this.$options.filters[filter](this.getDataField(field));
            }

            return this.getDataField(field);
        },
        initSplide()
        {
            if(this.qualityIcons.length <= 0) 
                return;

            if(this.splide)
            {
                this.splide.destroy();
            }

            this.splide = new Splide(this.$refs.qualityIcons, {
                type: 'slide',
                focus: 'center',
                arrows: true,
                autoWidth: true,
                perMove: 1,
                pagination: false,
                initialSlide: 0,
                dragMinThreshold: {
                    mouse: 0,
                    touch: 5
                }
            }).mount();
        },
        // iterate recursively the children components and call their hydrate method, if it is a lazy-hydrate component
        hydrateChildren(nodes)
        {
            nodes.forEach(component => {
                if (component.$options.name === "lazy-hydrate")
                {
                    component.hydrate();
                }
                else if (component.$children.length)
                {
                    this.hydrateChildren(component.$children);
                }
            })
        }
    }
}
</script>
